import { render, staticRenderFns } from "./PlatformDeposit.vue?vue&type=template&id=157665b0"
import script from "./PlatformDeposit.vue?vue&type=script&lang=js"
export * from "./PlatformDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports